/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BillsApplay } from '../models/bills-applay';
import { BillsApplayWithRelations } from '../models/bills-applay-with-relations';
import { NewBillsApplay } from '../models/new-bills-applay';

@Injectable({
  providedIn: 'root',
})
export class BillsApplayControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation billsApplayControllerCreateOrderNumber
   */
  static readonly BillsApplayControllerCreateOrderNumberPath = '/bills-applays/createOrderNumber';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrderNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrderNumber$Response(params?: {
    context?: HttpContext
    body?: NewBillsApplay
  }
): Observable<StrictHttpResponse<BillsApplay>> {

    const rb = new RequestBuilder(this.rootUrl, BillsApplayControllerService.BillsApplayControllerCreateOrderNumberPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BillsApplay>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrderNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrderNumber(params?: {
    context?: HttpContext
    body?: NewBillsApplay
  }
): Observable<BillsApplay> {

    return this.createOrderNumber$Response(params).pipe(
      map((r: StrictHttpResponse<BillsApplay>) => r.body as BillsApplay)
    );
  }

  /**
   * Path part for operation billsApplayControllerGetAllDataByEmplid
   */
  static readonly BillsApplayControllerGetAllDataByEmplidPath = '/bills-applays/emplid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetAllDataByEmplid()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAllDataByEmplid$Response(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<BillsApplayWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, BillsApplayControllerService.BillsApplayControllerGetAllDataByEmplidPath, 'get');
    if (params) {
      rb.query('emplid', params.emplid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BillsApplayWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `GetAllDataByEmplid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAllDataByEmplid(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<Array<BillsApplayWithRelations>> {

    return this.GetAllDataByEmplid$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BillsApplayWithRelations>>) => r.body as Array<BillsApplayWithRelations>)
    );
  }

  /**
   * Path part for operation billsApplayControllerFindBillsData
   */
  static readonly BillsApplayControllerFindBillsDataPath = '/bills-applays';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findBillsData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findBillsData$Response(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<Array<BillsApplayWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, BillsApplayControllerService.BillsApplayControllerFindBillsDataPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BillsApplayWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findBillsData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findBillsData(params?: {
    context?: HttpContext
    body?: {
}
  }
): Observable<Array<BillsApplayWithRelations>> {

    return this.findBillsData$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BillsApplayWithRelations>>) => r.body as Array<BillsApplayWithRelations>)
    );
  }

  /**
   * Path part for operation billsApplayControllerFileDownload
   */
  static readonly BillsApplayControllerFileDownloadPath = '/fileoperation/fileDownload/{model}/{filename}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileDownload()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDownload$Response(params: {
    model: string;
    filename: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BillsApplayControllerService.BillsApplayControllerFileDownloadPath, 'get');
    if (params) {
      rb.path('model', params.model, {});
      rb.path('filename', params.filename, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fileDownload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileDownload(params: {
    model: string;
    filename: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.fileDownload$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation billsApplayControllerUploadFileAndData
   */
  static readonly BillsApplayControllerUploadFileAndDataPath = '/filesave/uploadFileAndData/{module}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadFileAndData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFileAndData$Response(params: {
    module: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BillsApplayControllerService.BillsApplayControllerUploadFileAndDataPath, 'post');
    if (params) {
      rb.path('module', params.module, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadFileAndData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFileAndData(params: {
    module: string;
    context?: HttpContext

    /**
     * multipart/form-data value.
     */
    body: {
}
  }
): Observable<{
}> {

    return this.uploadFileAndData$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation billsApplayControllerGetFile
   */
  static readonly BillsApplayControllerGetFilePath = '/rohs-file/{model}/{url}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFile$Response(params: {
    model: string;
    url: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'fileUrl'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, BillsApplayControllerService.BillsApplayControllerGetFilePath, 'get');
    if (params) {
      rb.path('model', params.model, {});
      rb.path('url', params.url, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'fileUrl'?: string;
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFile(params: {
    model: string;
    url: string;
    context?: HttpContext
  }
): Observable<{
'fileUrl'?: string;
}> {

    return this.getFile$Response(params).pipe(
      map((r: StrictHttpResponse<{
'fileUrl'?: string;
}>) => r.body as {
'fileUrl'?: string;
})
    );
  }

  /**
   * Path part for operation billsApplayControllerDeleteByName
   */
  static readonly BillsApplayControllerDeleteByNamePath = '/sfe-file/{url}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteByName()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteByName$Response(params: {
    url: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, BillsApplayControllerService.BillsApplayControllerDeleteByNamePath, 'delete');
    if (params) {
      rb.path('url', params.url, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteByName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteByName(params: {
    url: string;
    context?: HttpContext
  }
): Observable<any> {

    return this.deleteByName$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
